import React from 'react';
import { Edit, SimpleForm, TextInput, SelectInput, ShowButton } from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import ISConfig from '../config';
import CardActions from "@material-ui/core/CardActions";
import BackButton from '../components/BackButton';
import CustomAddressInput from '../components/CustomAddressInput';
import RoomIcon from '@material-ui/icons/Room';
import CustomLabelInput from '../components/CustomLabelInput';

const CustomersEditActions = ({ basePath, data }) => (
    <CardActions>
        <BackButton style={{ marginRight: "auto" }}></BackButton>
        <ShowButton basePath={basePath} record={data} />
    </CardActions>
);

const CustomerEditGeneral = ({ record }) => {
    var CustomerStatusSelectChoices = [];
    ISConfig.statuses.customer.forEach(element => { CustomerStatusSelectChoices.push({ id: element, name: element }) });

    return (
        <div className="row mb-3 mb-md-0">
            <div className="col-12 col-xs-12 col-md-6">
                <div className="row">
                    <div className="col-4 col-xs-2 col-sm-4 col-md-3">
                        <TextInput source="client_code" className="p-0" label={<CustomLabelInput label="Client Code" />} fullWidth variant="outlined" />
                    </div>
                    <div className="col-8 col-xs-6 col-sm-6 col-md-5">
                        <TextInput disabled={ISConfig.qbi} source="name" label={<CustomLabelInput label="Name" />} fullWidth variant="outlined" />
                    </div>
                    <div className="col">
                        <SelectInput source="status" label={<CustomLabelInput label="Status" />} choices={CustomerStatusSelectChoices} fullWidth variant="outlined" />
                    </div>
                    <div className="col-12">
                        <TextInput disabled={ISConfig.qbi} source="email" label={<CustomLabelInput label="Email" />} fullWidth variant="outlined" />
                    </div>
                </div>
            </div>
            <div className="col-12 col-xs-12 col-md-6 px-4 pt-1">
                <CustomerEditNotes record={record} />
            </div>
        </div>
    );
};

const CustomerEditNotes = ({ record }) => {
    return (
        <div className="row">
            <div className="rounded" style={{ border: '1px solid', borderColor: 'rgb(211, 211, 211)' }}>
                <RichTextInput source="notes" label="Notes" stripTags emptyText="Notes" />
            </div>
        </div>
    );
};

const CustomerEdit = (props) => {
    let TitleEditCustomer = <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Edit Customer</h3>
    if (ISConfig.qbi) {
        return (
            <>
                {TitleEditCustomer}
                <Edit className="m-0 p-0" title=" " actions={<CustomersEditActions />} {...props}>
                    <SimpleForm redirect="show">
                        <CustomerEditGeneral record={{ ...props }} />
                    </SimpleForm>
                </Edit>
            </>
        )
    } else {
        return (
            <>
                {TitleEditCustomer}
                <Edit className="m-0 p-0" title=" " actions={<CustomersEditActions />} {...props} redirect="show">
                    <SimpleForm redirect="show">
                        <CustomerEditGeneral record={{ ...props }} />
                        <h6 className="font-weight-normal">{<RoomIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Address</h6>
                        <div className="w-100 mt-3">
                            <CustomAddressInput record={{ ...props }} />
                        </div>
                    </SimpleForm>
                </Edit>
            </>
        )
    }
};

export default CustomerEdit;
